import { gql } from '@apollo/client';
import { DiagnosisFragment, InsuranceFragment, PatientFragment } from '@/shared/api';
import OnBoardingFragment from '@/entities/study/api/fragments/onBoardingFragment';
import StudySettingFragment from '@/entities/study/api/fragments/studySettingFragment';

const UPDATE_STUDY_MUTATION = gql`
  mutation updateStudy($studyId: ID!, $props: UpdateStudyInput!) {
    updateStudy(studyId: $studyId, props: $props) {
      isSuccess
      message
      study {
        id
        friendlyId
        referenceCode
        isBiofluxDirect
        lowCellSignal
        rma
        onboarding {
          ...OnBoardingFragment
        }
        info {
          insurance {
            ...InsuranceFragment
          }
          patient {
            ...PatientFragment
          }
          interprettingPhysician {
            id
            firstName
            lastName
            contact {
              phone1
              nightPhone
              fax
            }
            email
          }
          referringPhysician {
            id
            firstName
            lastName
            contact {
              phone1
              nightPhone
              fax
            }
            email
          }
          diagnosis {
            ...DiagnosisFragment
          }
          followOnStudy {
            duration
            studyType
            reportDueDate
          }
        }
        studyHistory {
          time
          batteryLevel
          status
        }
        deviceNotifications {
          time
          batteryLevel
          status
        }
        reports {
          id
          reportId
          type
          createdAt
          start
          stop
          status
          event {
            friendlyId
            id
          }
          technicianComments
          physicianInterpretation
          isNotificationReport
          lastModified
          inbox {
            date
            priority
          }
          isArtifactReport
        }
        start
        stop
        studyType
        status
        reportDueDate
        studyNote
        timezone
        initDuration
        linkedStudies {
          id
          friendlyId
          initDuration
          studyType
          reportDueDate
        }
        studySetting {
          ...StudySettingFragment
        }
        facility {
          id
          name
          contact {
            country
          }
          arrears
        }
        device {
          id
          deviceId
          status
          model
          lastSync {
            operator
            gprs
            schema
          }
        }
      }
    }
  }

  ${OnBoardingFragment}
  ${InsuranceFragment}
  ${PatientFragment}
  ${DiagnosisFragment}
  ${StudySettingFragment}
`;

export default UPDATE_STUDY_MUTATION;
